import { Injectable } from '@angular/core';
import { MSALService } from './msal.service';
import { Configuration } from '@content-platform/web-angular-shared-util-configuration';
import { filter, map } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "./msal.service";
/**
 * Resolver used for the login route, to retrieve the user login information for the
 * adal service.
 * Example:
 * ```ts
 * { path: 'login', component: LoginComponent, resolve: { user: HandleAdCallbackResolver } }
 * ```
 *
 * @export
 * @class HandleAdCallbackResolver
 */
export class HandleAdCallbackResolver {
    constructor(msalService) {
        this.msalService = msalService;
    }
    resolve() {
        return this.adalConfigLoaded().pipe(filter(loaded => loaded), map(() => {
            this.msalService.handleCallback();
            if (this.msalService.getisAuthenticated()) {
                return this.msalService.getUserAccount();
            }
            return false;
        }));
    }
    adalConfigLoaded() {
        return Configuration.getAsync('adal').pipe(map(config => {
            console.log(config);
            return !!config;
        }));
    }
    static { this.ɵfac = function HandleAdCallbackResolver_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HandleAdCallbackResolver)(i0.ɵɵinject(i1.MSALService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HandleAdCallbackResolver, factory: HandleAdCallbackResolver.ɵfac }); }
}
//# sourceMappingURL=handle-ad-callback.resolver.js.map